// extracted by mini-css-extract-plugin
export default {"Footer":"H_G6V3bo","logo":"b5DeW1o5","container":"pMZgYXRX","contactBlock":"O8n9702N","footerLink":"ybs_MFSU","policy":"jTQU_b3I","socialIcons":"CmW1lKkJ"};
    if(module.hot) {
      // 1764331282205
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  